<template>
  <b-modal header-close-content="" id="general-options-modal" :title="$t('options')" ok-only :ok-disabled="!isValid" @hidden="updateOptions">
    <div class="pt-1 w-50">
      <strong class="pt-0"> {{ $t("menubar.options.multiAttributeSeparator") }}</strong>
      <input
        maxLength="1"
        type="text"
        class="form-control"
        v-model="parameters.MultiAttributeValueSeparator"
        data-cy="attribute-manager-contextmenu-multi-select-seperator-txt" />
    </div>
  </b-modal>
</template>

<script>
import { mapState } from "vuex";
import { mapActions } from "vuex";

export default {
  components: {},
  data() {
    return {
      parameters: {
        MultiAttributeValueSeparator: ";"
      }
    };
  },
  computed: {
    ...mapState(["globalParameters"]),
    isValid() {
      return this.parameters.MultiAttributeValueSeparator;
    },
    isDirty() {
      return this.parameters.MultiAttributeValueSeparator !== this.globalParameters.MultiAttributeValueSeparator;
    }
  },
  methods: {
    ...mapActions(["saveGlobalParameters"]),
    updateOptions() {
      if (this.isValid) {
        if (this.isDirty) this.saveGlobalParameters(this.parameters);
      } else this.parameters.MultiAttributeValueSeparator = this.globalParameters.MultiAttributeValueSeparator;
    }
  },
  watch: {
    globalParameters: {
      immediate: true,
      deep: true,
      handler(nv) {
        if (!nv) return;
        Object.assign(this.parameters, {
          MultiAttributeValueSeparator: nv.MultiAttributeValueSeparator
        });
      }
    }
  }
};
</script>
